
import { Component, Prop, Vue } from 'vue-property-decorator';

const DELAY = 100; // in milliseconds

@Component
export default class Alert extends Vue {
  @Prop({ type: String, required: true }) readonly type!: string;

  @Prop({ type: Boolean, default: false }) readonly timed!: boolean;

  @Prop({ type: Boolean, default: false }) readonly dismissible!: boolean;

  @Prop({ type: Number, default: 3000 }) readonly totalShowTime!: number;

  showTime = 0;

  interval: ReturnType<typeof setInterval> | null = null;

  get className() {
    return `${this.type}-alert`;
  }

  get icon(): string {
    if (this.type === 'warning') {
      return 'mdi-alert-outline';
    }
    if (this.type === 'error' || this.type === 'input-error') {
      return 'mdi-alert-circle-outline';
    }

    return 'mdi-checkbox-marked-circle';
  }

  get progressBarPercentage(): number {
    return (100 / this.totalShowTime) * this.showTime;
  }

  get alertColorVariable(): string {
    if (this.type === 'input-error') {
      return 'var(--error-color)';
    }
    return `var(--${this.type}-color)`;
  }

  close() {
    this.clearInterval();
    this.$emit('dismissed');
  }

  private clearInterval() {
    if (this.interval) clearInterval(this.interval);
  }

  mounted() {
    if (!this.timed) return;

    this.showTime = this.totalShowTime;

    this.interval = setInterval(() => {
      if (this.showTime < 0) {
        this.close();
      } else {
        this.showTime -= DELAY;
      }
    }, DELAY);
  }

  destroyed() {
    this.clearInterval();
  }
}
